<template>
  <div>
    <div ref="echartBing" :style="{width: '100%', height: '320px'}"></div>
  </div>
</template>

<script>
import { lang_fend } from "@/network/index";
export default {
  props: {
    topobjdata: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      dataObjs: {},
      lang_file: sessionStorage.getItem("lang_file"),
    };
  },
  created() {},
  mounted() {
    this.lang_fend();
  },
  methods: {
    async lang_fend() {
      let page = "home_page";
      let objs = {
        page,
        lang_file: this.lang_file,
      };
      const { data, code } = await lang_fend(objs);
      // console.log(data);
      this.dataObjs = data;
      // this.echarBing();
    },
    echarBing(objData) {
      console.log(objData, "----");
      let myChart = this.$echarts.init(this.$refs.echartBing);
      let option = {
        title: {
          //   text: "某站点用户访问来源",
          //   subtext: "纯属虚构",
          left: "center",
        },
        tooltip: {
          trigger: "item",
          formatter: "{b} : {c} ({d}%)",
        },
        legend: {
          // orient: "vertical",
          orient: "horizontal",
          x: "center",
          center: "center",
          data: [
            this.dataObjs.zhengchang,
            this.dataObjs.baojing,
            this.dataObjs.lixian,
            this.dataObjs.canshuguzhang,
          ],
        },
        series: [
          {
            // name: "访问来源",
            type: "pie",
            radius: "55%",
            center: ["50%", "60%"],
            data: [
              {
                value: Number(objData.onlinecount),
                name: this.dataObjs.zhengchang,
                itemStyle:{
                  color:'#00AE72'
                }
              },
              {
                value: Number(objData.alarmcount),
                name: this.dataObjs.baojing,
                  itemStyle:{
                  color:'#C50023'
                }
              },
              {
                value: Number(objData.offlinecount),
                name: this.dataObjs.lixian,
                 itemStyle:{
                  color:'#363636'
                }
              },
              {
                value: Number(objData.errorcount),
                name: this.dataObjs.canshuguzhang,
                  itemStyle:{
                  color:'#5D0C7B'
                }
              },
            ],
            // 显示次数
             label: {
              normal: {
              show: true,
              formatter: function (params) {
                  return params.name + " " + +params.value + " 次"
               }
              }
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      myChart.setOption(option);
    },
  },
};
</script>

<style scoped lang="less">
</style>
